<div class="popup-div">
  <p (click)="routeToPath('editLead')" [ngStyle]="{ 'display': hideLeadEditButton ? 'block' : 'none' }">Edit Lead</p>
  <!-- <p (click)="routeToPath('addVoucher')">Add Voucher</p> -->
  <p (click)="routeToPath('addInvoice')" *ngIf="showInvoice && createInvoice">Add Invoice</p>
  <p (click)="routeToPath('addQuote')" *ngIf="showCreateQuoteButton">Add Quote</p>
  <p (click)="routeToPath('addPassenger')">Add Passenger</p>
  <p (click)="routeToPath('addTask')" *ngIf="hideCreateTask">Add Task</p>
</div>